exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-detail[data-v-2646726f]:after{content:\"\";display:block;clear:both}.detail-w[data-v-2646726f]{width:var(--portalContainerWidth)}.detail-w .ql-editor[data-v-2646726f]{padding:12px 0}.hyperlink-color[data-v-2646726f]{color:#3b9bf0}[data-v-2646726f] .ql-container.ql-snow{border:none}[data-v-2646726f] .ql-align-center img{display:inline-block}", ""]);

// exports
